const PUBLIC_MODE_TEXT = 'Public';
const SECURE_MODE_TEXT = 'Secure';

const PUBLIC_MODE_VALUE = 'public';
const SECURE_MODE_VALUE = 'secure';

const storageTwnelModes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: PUBLIC_MODE_TEXT,
    value: PUBLIC_MODE_VALUE,
  },
  {
    text: SECURE_MODE_TEXT,
    value: SECURE_MODE_VALUE,
  },
];

export default storageTwnelModes;
